// Mock data for Cape Atlantic Tours

export const tours = [
  {
    id: 'peninsula-package',
    title: 'Peninsula Package',
    description: 'Experience the breathtaking Cape Peninsula with visits to iconic landmarks, pristine beaches, and witness where the warm Agulhas Current meets the cold Benguela Current at the southwestern tip of Africa.',
    duration: 'Full day',
    price: 2550,
    image: 'https://images.unsplash.com/photo-1682354499691-3ebb4f6da3ee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHw0fHxDYXBlJTIwUG9pbnR8ZW58MHx8fHwxNzcwNDk5MTExfDA&ixlib=rb-4.1.0&q=85',
    category: 'sightseeing',
    highlights: ['Cape Point lighthouse', 'Cape of Good Hope', 'Boulders Beach penguins', 'Chapman\'s Peak Drive']
  },
  {
    id: 'wine-tasting',
    title: 'Wine Tasting in Stellenbosch',
    description: 'Indulge in a luxurious wine tasting experience visiting 2 award-winning wine estates in the renowned Stellenbosch wine region.',
    duration: 'Full day',
    price: 1500,
    image: 'https://images.unsplash.com/photo-1662961746377-0c970fef7ae4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHx3aW5lJTIwY2hlZXNlJTIwY2hhcmN1dGVyaWUlMjBib2FyZCUyMG91dGRvb3IlMjB0YWJsZXxlbnwwfHx8fDE3NzExNjQ0MDF8MA&ixlib=rb-4.1.0&q=85',
    category: 'luxury',
    highlights: ['2 wine estates', 'Professional sommelier', 'Wine tastings included', 'Scenic vineyard views']
  },
  {
    id: 'quad-biking',
    title: 'Quad Biking on White Sandy Dunes',
    description: 'Experience the ultimate adrenaline rush riding through spectacular white sand dunes. Feel the thrill as you navigate the pristine dunes.',
    duration: '3 hours',
    price: 1650,
    image: 'https://images.unsplash.com/photo-1769450290445-3daed0c8fe63?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxBVFYlMjBxdWFkJTIwYmlrZSUyMGRlc2VydCUyMHNhbmQlMjBkdW5lc3xlbnwwfHx8fDE3NzExNjQ0MTJ8MA&ixlib=rb-4.1.0&q=85',
    category: 'adventure',
    highlights: ['Professional guides', 'Safety equipment included', 'Photo opportunities', 'Refreshments provided']
  },
  {
    id: 'city-escape',
    title: 'Cape Town City Escape',
    description: 'Discover the vibrant heart of Cape Town with visits to iconic Bo-Kaap, Table Mountain, Signal Hill, and enjoy a delicious lunch.',
    duration: 'Full day',
    price: 2650,
    image: 'https://images.unsplash.com/photo-1604763655221-b98ebdac6ddf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxDYXBlJTIwVG93biUyMFRhYmxlJTIwTW91bnRhaW58ZW58MHx8fHwxNzcwNDk5MDc3fDA&ixlib=rb-4.1.0&q=85',
    category: 'sightseeing',
    highlights: ['Bo-Kaap colourful houses', 'Table Mountain cable car', 'Signal Hill viewpoint', 'Lunch included']
  },
  {
    id: 'safari-tour',
    title: 'Safari Day Tour - Africa\'s Big Five',
    description: 'Embark on an unforgettable safari adventure to view Africa\'s Big Five. Includes welcome drink, gourmet lunch, and luxury transportation.',
    duration: 'Full day',
    price: 8000,
    image: 'https://images.unsplash.com/photo-1516426122078-c23e76319801?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0fDB8MXxzZWFyY2h8Mnx8c2FmYXJpJTIwYWZyaWNhfGVufDB8fHx8MTczMTU4MzQyM3ww&ixlib=rb-4.1.0&q=85',
    category: 'adventure',
    highlights: ['View Big Five animals', 'Welcome drink on arrival', 'Gourmet lunch included', 'Professional guide & luxury transport']
  },
  {
    id: 'shark-cage-diving',
    title: 'Shark Cage Diving & Viewing Tours in Gansbaai',
    description: 'Face great white sharks in Gansbaai and Shark Alley with this experience. Start with breakfast and a safety briefing before boarding the boat. Then, slip into the cage for a close-up shark encounter or watch from the boat. Return to the harbor for a light lunch and a DVD viewing of the trip.',
    duration: 'Full day',
    price: 4295,
    image: 'https://images.unsplash.com/photo-1560275619-4662e36fa65c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxncmVhdCUyMHdoaXRlJTIwc2hhcmslMjBjYWdlJTIwZGl2aW5nfGVufDB8fHx8MTc5MTk4MTc0MXww&ixlib=rb-4.1.0&q=85',
    category: 'adventure',
    highlights: ['Great white shark encounters', 'Breakfast included', 'Wetsuit & diving mask provided', 'Lunch and snacks included', 'DVD of your experience'],
    galleryImages: [
      'https://images.unsplash.com/photo-1637308111472-fdf4886a2e07?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwzfHxncmVhdCUyMHdoaXRlJTIwc2hhcmslMjB1bmRlcndhdGVyJTIwY2xvc2UlMjB1cCUyMHByZWRhdG9yfGVufDB8fHx8MTc5MjA1OTY5M3ww&ixlib=rb-4.1.0&q=85',
      'https://images.unsplash.com/photo-1704694214588-24f4bae4757b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwyfHxncmVhdCUyMHdoaXRlJTIwc2hhcmslMjB1bmRlcndhdGVyJTIwY2xvc2UlMjB1cCUyMHByZWRhdG9yfGVufDB8fHx8MTc5MjA1OTY5M3ww&ixlib=rb-4.1.0&q=85',
      'https://images.unsplash.com/photo-1604337356887-49ae9d469fd7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxncmVhdCUyMHdoaXRlJTIwc2hhcmslMjBjYWdlJTIwZGl2aW5nJTIwdW5kZXJ3YXRlciUyMEdhbnNiYWFpfGVufDB8fHx8MTc5MjA1OTY5M3ww&ixlib=rb-4.1.0&q=85',
      'https://images.unsplash.com/photo-1637308111118-377f5725f37c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHw0fHxncmVhdCUyMHdoaXRlJTIwc2hhcmslMjB1bmRlcndhdGVyJTIwY2xvc2UlMjB1cCUyMHByZWRhdG9yfGVufDB8fHx8MTc5MjA1OTY5M3ww&ixlib=rb-4.1.0&q=85'
    ]
  },
  {
    id: 'robben-island',
    title: 'Robben Island Historical Tour',
    description: 'Join our exclusive Robben Island tour for a guaranteed, personalized, and historically rich experience, featuring a storytelling ferry ride and rare insights from a former political prisoner.',
    duration: 'Half day',
    price: 950,
    priceInternational: 1350,
    dualPricing: true,
    requiresIdNumber: true,
    image: 'https://images.unsplash.com/photo-1661112483600-bf3485542ec7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHw0fHxSb2JiZW4lMjBJc2xhbmQlMjBTb3V0aCUyMEFmcmljYSUyMHByaXNvbiUyMGhpc3RvcmljYWwlMjBzaXRlfGVufDB8fHx8MTc5MjA1NzgwNnww&ixlib=rb-4.1.0&q=85',
    category: 'sightseeing',
    highlights: ['Transfers included', 'Robben Island Museum entry & tour', 'Former prisoner guide', 'Return ferry tickets', 'SA ID required for booking'],
    specialNote: 'South African Citizens: R950pp | International Travelers: R1350pp. SA ID number required for booking.',
    galleryImages: [
      'https://images.unsplash.com/photo-1579109491659-2dd0df36f602?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxSb2JiZW4lMjBJc2xhbmQlMjBTb3V0aCUyMEFmcmljYSUyMHByaXNvbiUyMGhpc3RvcmljYWwlMjBzaXRlfGVufDB8fHx8MTc5MjA1NzgwNnww&ixlib=rb-4.1.0&q=85',
      'https://images.unsplash.com/photo-1579109696801-0193df954e47?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwzfHxSb2JiZW4lMjBJc2xhbmQlMjBTb3V0aCUyMEFmcmljYSUyMHByaXNvbiUyMGhpc3RvcmljYWwlMjBzaXRlfGVufDB8fHx8MTc5MjA1NzgwNnww&ixlib=rb-4.1.0&q=85',
      'https://images.unsplash.com/photo-1626894169601-482d26b23f35?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwzfHxSb2JiZW4lMjBJc2xhbmQlMjBmZXJyeSUyMENhcGUlMjBUb3duJTIwaGlzdG9yaWNhbCUyMHRvdXJ8ZW58MHx8fHwxNzkyMDU3ODAyfDA&ixlib=rb-4.1.0&q=85'
    ]
  },
  {
    id: 'big-game-fishing',
    title: 'Big Game Offshore Fishing Experience',
    description: 'One of the best places in the world for catching quality Yellowfin Tuna from 50kg to 100kg+, along with Bluefin, Big Eye and Longfin tuna. Seasonal and weather dependent fishing experience.',
    duration: 'Depends on weather conditions',
    price: 30000,
    priceType: 'per-group',
    maxGuests: 4,
    image: 'https://images.unsplash.com/photo-1707314175646-7f40247f36c0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHw0fHxkZWVwJTIwc2VhJTIwZmlzaGluZyUyMHR1bmElMjBjYXRjaCUyMHNwb3J0JTIwZmlzaGluZyUyMGJvYXR8ZW58MHx8fHwxNzkyMDU5MjkyfDA&ixlib=rb-4.1.0&q=85',
    category: 'adventure',
    highlights: ['One of the best fishing spots in the world', 'Yellowfin Tuna 50-100kg+', 'Bluefin, Big Eye, Longfin species', 'Transfers included', 'Weather dependent'],
    specialNote: 'R30,000 per group (maximum 4 people). Seasonal and weather dependent - contact us to discuss dates and weather windows.',
    galleryImages: [
      'https://images.unsplash.com/photo-1780505695937-a5d551b5d61b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwzfHxibHVlZmluJTIwdHVuYSUyMGJpZyUyMGV5ZSUyMHR1bmElMjBmaXNoaW5nJTIwY2F0Y2glMjBvY2VhbnxlbnwwfHx8fDE3OTIwNTk2OTN8MA&ixlib=rb-4.1.0&q=85',
      'https://images.unsplash.com/photo-1779122625604-892ed6069601?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHw0fHxibHVlZmluJTIwdHVuYSUyMGJpZyUyMGV5ZSUyMHR1bmElMjBmaXNoaW5nJTIwY2F0Y2glMjBvY2VhbnxlbnwwfHx8fDE3OTIwNTk2OTN8MA&ixlib=rb-4.1.0&q=85',
      'https://images.unsplash.com/photo-1562053923-52d3ebb09d31?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHxibHVlZmluJTIwdHVuYSUyMGJpZyUyMGV5ZSUyMHR1bmElMjBmaXNoaW5nJTIwY2F0Y2glMjBvY2VhbnxlbnwwfHx8fDE3OTIwNTk2OTN8MA&ixlib=rb-4.1.0&q=85',
      'https://images.unsplash.com/photo-1544288067-3467bd7e89a7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwyfHxibHVlZmluJTIwdHVuYSUyMGJpZyUyMGV5ZSUyMHR1bmElMjBmaXNoaW5nJTIwY2F0Y2glMjBvY2VhbnxlbnwwfHx8fDE3OTIwNTk2OTN8MA&ixlib=rb-4.1.0&q=85'
    ]
  },
  {
    id: 'whale-watching',
    title: 'Whale Watching Experience',
    description: 'Hout Bay hosts one of the most diverse whale watching locations in the world. Year-round sightings of Brydes, Southern Right whales, and spectacular Humpback whale super-groups of 20-100 whales feeding and breaching within metres of the boat.',
    duration: '2.5 to 3 hours',
    price: 3000,
    priceKids: 1000,
    dualPricing: true,
    pricingType: 'age-based',
    image: 'https://images.unsplash.com/photo-1568430462989-44163eb1752f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxodW1wYmFjayUyMHdoYWxlJTIwYnJlYWNoaW5nJTIwanVtcGluZyUyMG9jZWFuJTIwd2lsZGxpZmV8ZW58MHx8fHwxNzkyMDU5MjkyfDA&ixlib=rb-4.1.0&q=85',
    category: 'adventure',
    highlights: ['Launch from Hout Bay Harbour', 'Year-round whale sightings', 'Brydes, Humpback, Southern Right whales', 'Super-groups of 20-100 whales', 'Transfers included'],
    specialNote: 'Adults: R3,000 | Kids under 17: R1,000. A bucket list experience with Humpback whale migrations!',
    galleryImages: [
      'https://images.unsplash.com/photo-1759411949352-ed00f1e8a471?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxTb3V0aGVybiUyMFJpZ2h0JTIwd2hhbGUlMjBCcnlkZXMlMjB3aGFsZSUyMG9jZWFuJTIwU291dGglMjBBZnJpY2F8ZW58MHx8fHwxNzkyMDU5NjkzfDA&ixlib=rb-4.1.0&q=85',
      'https://images.unsplash.com/photo-1658298701588-d030766f7829?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwzfHxTb3V0aGVybiUyMFJpZ2h0JTIwd2hhbGUlMjBCcnlkZXMlMjB3aGFsZSUyMG9jZWFuJTIwU291dGglMjBBZnJpY2F8ZW58MHx8fHwxNzkyMDU5NjkzfDA&ixlib=rb-4.1.0&q=85',
      'https://images.unsplash.com/photo-1761663561824-d974ef12920f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxodW1wYmFjayUyMHdoYWxlJTIwcG9kJTIwZ3JvdXAlMjBmYW1pbHklMjBvY2VhbiUyMHdpbGRsaWZlfGVufDB8fHx8MTc5MjA1OTY5M3ww&ixlib=rb-4.1.0&q=85',
      'https://images.unsplash.com/photo-1730330727746-a2bf617ed7b8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwzfHxodW1wYmFjayUyMHdoYWxlJTIwcG9kJTIwZ3JvdXAlMjBmYW1pbHklMjBvY2VhbiUyMHdpbGRsaWZlfGVufDB8fHx8MTc5MjA1OTY5M3ww&ixlib=rb-4.1.0&q=85',
      'https://images.unsplash.com/photo-1658307433457-244e8e9d72fd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHw0fHxTb3V0aGVybiUyMFJpZ2h0JTIwd2hhbGUlMjBCcnlkZXMlMjB3aGFsZSUyMG9jZWFuJTIwU291dGglMjBBZnJpY2F8ZW58MHx8fHwxNzkyMDU5NjkzfDA&ixlib=rb-4.1.0&q=85'
    ]
  }
];

export const services = [
  {
    id: 'airport-transfer',
    title: 'Airport Transfers',
    description: 'Reliable and punctual airport pickup and drop-off services in luxury vehicles.',
    icon: 'Plane',
    price: 'R500 per transfer',
    image: 'https://images.unsplash.com/photo-1758411898418-adce5340c452?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHw0fHxINiUyMDIuMCUyMEdUJTIwc3VwZXIlMjBsdXh1cnklMjB3aGl0ZSUyMFNVVnxlbnwwfHx8fDE3OTE5NzEzNTV8MA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 'chauffeur',
    title: 'Bespoke Chauffeur Services',
    description: 'Customized chauffeur-driven luxury vehicles tailored to your specific requirements.',
    icon: 'Car',
    price: 'Contact for pricing',
    image: 'https://images.unsplash.com/photo-1710909637342-4f7e8e90ef2b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxINiUyMDIuMCUyMEdUJTIwc3VwZXIlMjBsdXh1cnklMjB3aGl0ZSUyMFNVVnxlbnwwfHx8fDE3OTE5NzEzNTV8MA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 'vip-security',
    title: 'Bespoke VIP Protection & Security',
    description: 'Discreet and professional security services customized for high-profile clients and special requirements.',
    icon: 'Shield',
    price: 'Contact for pricing',
    image: 'https://images.unsplash.com/photo-1758384076382-21f6587e1048?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBjaGF1ZmZldXIlMjBibGFjayUyMGNhcnxlbnwwfHx8fDE3NzA0OTkxNTl8MA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 'private-chef',
    title: 'Private Chef',
    description: 'Exquisite dining experiences with our award-winning private chefs.',
    icon: 'ChefHat',
    price: 'Contact for pricing',
    image: 'https://images.unsplash.com/photo-1761095596755-99ba58997720?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHxnb3VybWV0JTIwZm9vZCUyMHBsYXRpbmclMjByZXN0YXVyYW50JTIwZGlzaHxlbnwwfHx8fDE3NzExNjQ0MDZ8MA&ixlib=rb-4.1.0&q=85'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Sarah Johnson',
    location: 'London, UK',
    rating: 5,
    text: 'The Peninsula Package was absolutely incredible! Our guide was knowledgeable and the views at Cape Point were breathtaking. Seeing the penguins at Boulders Beach was a highlight!',
    tour: 'Peninsula Package',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop'
  },
  {
    id: 2,
    name: 'Michael Chen',
    location: 'Singapore',
    rating: 5,
    text: 'The quad biking on white sandy dunes was thrilling! Professional staff, top-notch equipment, and breathtaking scenery. Highly recommend for adventure seekers.',
    tour: 'Quad Biking',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop'
  },
  {
    id: 3,
    name: 'Emma Williams',
    location: 'Sydney, Australia',
    rating: 5,
    text: 'The Cape Town City Escape was perfect! Bo-Kaap was so colorful, Table Mountain views were stunning, and lunch was delicious. Best day ever!',
    tour: 'City Escape',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop'
  },
  {
    id: 4,
    name: 'David Martinez',
    location: 'New York, USA',
    rating: 5,
    text: 'The Safari Day Tour was unforgettable! We saw all of the Big Five. The welcome drink and gourmet lunch were excellent. Worth every penny!',
    tour: 'Safari Tour',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop'
  }
];

export const galleryImages = [
  {
    id: 1,
    url: 'https://images.unsplash.com/photo-1708747956368-7583058615a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwzfHxDYXBlJTIwVG93biUyMFRhYmxlJTIwTW91bnRhaW58ZW58MHx8fHwxNzcwNDk5MDc3fDA&ixlib=rb-4.1.0&q=85',
    title: 'Cape Town Aerial View',
    category: 'sightseeing'
  },
  {
    id: 2,
    url: 'https://images.unsplash.com/photo-1769450290445-3daed0c8fe63?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwyfHxxdWFkJTIwYmlraW5nJTIwZHVuZXN8ZW58MHx8fHwxNzcwNDk5MDg3fDA&ixlib=rb-4.1.0&q=85',
    title: 'Quad Biking Adventure',
    category: 'adventure'
  },
  {
    id: 3,
    url: 'https://images.unsplash.com/photo-1633338001234-63ede6a2c0e9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHx3aW5lJTIwdGFzdGluZyUyMHZpbmV5YXJkfGVufDB8fHx8MTc3MDQ5OTA5NXww&ixlib=rb-4.1.0&q=85',
    title: 'Vineyard Landscapes',
    category: 'luxury'
  },
  {
    id: 4,
    url: 'https://images.unsplash.com/photo-1552596160-2972cb5d9fc2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxDYXBlJTIwUG9pbnR8ZW58MHx8fHwxNzcwNDk5MTExfDA&ixlib=rb-4.1.0&q=85',
    title: 'Cape Point Waves',
    category: 'sightseeing'
  },
  {
    id: 5,
    url: 'https://images.unsplash.com/photo-1722644903609-d6390e6ef941?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHw0fHxDYXBlJTIwVG93biUyMFRhYmxlJTIwTW91bnRhaW58ZW58MHx8fHwxNzcwNDk5MDc3fDA&ixlib=rb-4.1.0&q=85',
    title: 'Table Mountain Road',
    category: 'sightseeing'
  },
  {
    id: 6,
    url: 'https://images.unsplash.com/photo-1763867641419-6661da25dbec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHw0fHx3aW5lJTIwdGFzdGluZyUyMHZpbmV5YXJkfGVufDB8fHx8MTc3MDQ5OTA5NXww&ixlib=rb-4.1.0&q=85',
    title: 'Wine Country',
    category: 'luxury'
  },
  {
    id: 7,
    url: 'https://images.unsplash.com/photo-1565104013743-e8426eb9de33?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxDYXBlJTIwUG9pbnR8ZW58MHx8fHwxNzcwNDk5MTExfDA&ixlib=rb-4.1.0&q=85',
    title: 'Dramatic Coastal Cliffs',
    category: 'sightseeing'
  },
  {
    id: 8,
    url: 'https://images.unsplash.com/photo-1551973931-83ed7323ea15?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxDYXBlJTIwUG9pbnR8ZW58MHx8fHwxNzcwNDk5MTExfDA&ixlib=rb-4.1.0&q=85',
    title: 'Ocean Aerial',
    category: 'sightseeing'
  },
  // Great White Shark Images
  {
    id: 9,
    url: 'https://images.unsplash.com/photo-1637308111472-fdf4886a2e07?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwzfHxncmVhdCUyMHdoaXRlJTIwc2hhcmslMjB1bmRlcndhdGVyJTIwY2xvc2UlMjB1cCUyMHByZWRhdG9yfGVufDB8fHx8MTc5MjA1OTY5M3ww&ixlib=rb-4.1.0&q=85',
    title: 'Great White Shark - Gansbaai',
    category: 'adventure'
  },
  {
    id: 10,
    url: 'https://images.unsplash.com/photo-1704694214588-24f4bae4757b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwyfHxncmVhdCUyMHdoaXRlJTIwc2hhcmslMjB1bmRlcndhdGVyJTIwY2xvc2UlMjB1cCUyMHByZWRhdG9yfGVufDB8fHx8MTc5MjA1OTY5M3ww&ixlib=rb-4.1.0&q=85',
    title: 'Shark Cage Diving Experience',
    category: 'adventure'
  },
  {
    id: 11,
    url: 'https://images.unsplash.com/photo-1604337356887-49ae9d469fd7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxncmVhdCUyMHdoaXRlJTIwc2hhcmslMjBjYWdlJTIwZGl2aW5nJTIwdW5kZXJ3YXRlciUyMEdhbnNiYWFpfGVufDB8fHx8MTc5MjA1OTY5M3ww&ixlib=rb-4.1.0&q=85',
    title: 'Shark Encounter - Shark Alley',
    category: 'adventure'
  },
  {
    id: 12,
    url: 'https://images.unsplash.com/photo-1637308111118-377f5725f37c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHw0fHxncmVhdCUyMHdoaXRlJTIwc2hhcmslMjB1bmRlcndhdGVyJTIwY2xvc2UlMjB1cCUyMHByZWRhdG9yfGVufDB8fHx8MTc5MjA1OTY5M3ww&ixlib=rb-4.1.0&q=85',
    title: 'Great White Close-Up',
    category: 'adventure'
  },
  // Big Game Fishing - Tuna Species
  {
    id: 13,
    url: 'https://images.unsplash.com/photo-1780505695937-a5d551b5d61b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwzfHxibHVlZmluJTIwdHVuYSUyMGJpZyUyMGV5ZSUyMHR1bmElMjBmaXNoaW5nJTIwY2F0Y2glMjBvY2VhbnxlbnwwfHx8fDE3OTIwNTk2OTN8MA&ixlib=rb-4.1.0&q=85',
    title: 'Bluefin Tuna - Big Game Fishing',
    category: 'adventure'
  },
  {
    id: 14,
    url: 'https://images.unsplash.com/photo-1779122625604-892ed6069601?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHw0fHxibHVlZmluJTIwdHVuYSUyMGJpZyUyMGV5ZSUyMHR1bmElMjBmaXNoaW5nJTIwY2F0Y2glMjBvY2VhbnxlbnwwfHx8fDE3OTIwNTk2OTN8MA&ixlib=rb-4.1.0&q=85',
    title: 'Big Eye Tuna',
    category: 'adventure'
  },
  {
    id: 15,
    url: 'https://images.unsplash.com/photo-1562053923-52d3ebb09d31?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHxibHVlZmluJTIwdHVuYSUyMGJpZyUyMGV5ZSUyMHR1bmElMjBmaXNoaW5nJTIwY2F0Y2glMjBvY2VhbnxlbnwwfHx8fDE3OTIwNTk2OTN8MA&ixlib=rb-4.1.0&q=85',
    title: 'Yellowfin Tuna School',
    category: 'adventure'
  },
  {
    id: 16,
    url: 'https://images.unsplash.com/photo-1544288067-3467bd7e89a7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwyfHxibHVlZmluJTIwdHVuYSUyMGJpZyUyMGV5ZSUyMHR1bmElMjBmaXNoaW5nJTIwY2F0Y2glMjBvY2VhbnxlbnwwfHx8fDE3OTIwNTk2OTN8MA&ixlib=rb-4.1.0&q=85',
    title: 'Longfin Tuna',
    category: 'adventure'
  },
  // Whale Watching Images
  {
    id: 17,
    url: 'https://images.unsplash.com/photo-1759411949352-ed00f1e8a471?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxTb3V0aGVybiUyMFJpZ2h0JTIwd2hhbGUlMjBCcnlkZXMlMjB3aGFsZSUyMG9jZWFuJTIwU291dGglMjBBZnJpY2F8ZW58MHx8fHwxNzkyMDU5NjkzfDA&ixlib=rb-4.1.0&q=85',
    title: 'Southern Right Whale',
    category: 'adventure'
  },
  {
    id: 18,
    url: 'https://images.unsplash.com/photo-1658298701588-d030766f7829?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwzfHxTb3V0aGVybiUyMFJpZ2h0JTIwd2hhbGUlMjBCcnlkZXMlMjB3aGFsZSUyMG9jZWFuJTIwU291dGglMjBBZnJpY2F8ZW58MHx8fHwxNzkyMDU5NjkzfDA&ixlib=rb-4.1.0&q=85',
    title: 'Brydes Whale Surfacing',
    category: 'adventure'
  },
  {
    id: 19,
    url: 'https://images.unsplash.com/photo-1761663561824-d974ef12920f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxodW1wYmFjayUyMHdoYWxlJTIwcG9kJTIwZ3JvdXAlMjBmYW1pbHklMjBvY2VhbiUyMHdpbGRsaWZlfGVufDB8fHx8MTc5MjA1OTY5M3ww&ixlib=rb-4.1.0&q=85',
    title: 'Humpback Whale Breaching',
    category: 'adventure'
  },
  {
    id: 20,
    url: 'https://images.unsplash.com/photo-1730330727746-a2bf617ed7b8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwzfHxodW1wYmFjayUyMHdoYWxlJTIwcG9kJTIwZ3JvdXAlMjBmYW1pbHklMjBvY2VhbiUyMHdpbGRsaWZlfGVufDB8fHx8MTc5MjA1OTY5M3ww&ixlib=rb-4.1.0&q=85',
    title: 'Humpback Whale Super-Group',
    category: 'adventure'
  },
  {
    id: 21,
    url: 'https://images.unsplash.com/photo-1658307433457-244e8e9d72fd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHw0fHxTb3V0aGVybiUyMFJpZ2h0JTIwd2hhbGUlMjBCcnlkZXMlMjB3aGFsZSUyMG9jZWFuJTIwU291dGglMjBBZnJpY2F8ZW58MHx8fHwxNzkyMDU5NjkzfDA&ixlib=rb-4.1.0&q=85',
    title: 'Whale Watching - Hout Bay',
    category: 'adventure'
  },
  // Robben Island Images
  {
    id: 22,
    url: 'https://images.unsplash.com/photo-1579109491659-2dd0df36f602?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxSb2JiZW4lMjBJc2xhbmQlMjBTb3V0aCUyMEFmcmljYSUyMHByaXNvbiUyMGhpc3RvcmljYWwlMjBzaXRlfGVufDB8fHx8MTc5MjA1NzgwNnww&ixlib=rb-4.1.0&q=85',
    title: 'Robben Island Prison Watchtower',
    category: 'sightseeing'
  },
  {
    id: 23,
    url: 'https://images.unsplash.com/photo-1579109696801-0193df954e47?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwzfHxSb2JiZW4lMjBJc2xhbmQlMjBTb3V0aCUyMEFmcmljYSUyMHByaXNvbiUyMGhpc3RvcmljYWwlMjBzaXRlfGVufDB8fHx8MTc5MjA1NzgwNnww&ixlib=rb-4.1.0&q=85',
    title: 'Robben Island Prison Corridor',
    category: 'sightseeing'
  },
  {
    id: 24,
    url: 'https://images.unsplash.com/photo-1626894169601-482d26b23f35?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwzfHxSb2JiZW4lMjBJc2xhbmQlMjBmZXJyeSUyMENhcGUlMjBUb3duJTIwaGlzdG9yaWNhbCUyMHRvdXJ8ZW58MHx8fHwxNzkyMDU3ODAyfDA&ixlib=rb-4.1.0&q=85',
    title: 'Robben Island Ferry View',
    category: 'sightseeing'
  }
];

export const faqs = [
  {
    id: 1,
    question: 'What is included in the tour price?',
    answer: 'All our tours include professional guides, transport, and entry fees. The City Escape includes lunch, and the Safari Tour includes a welcome drink and gourmet lunch. Specific inclusions are listed for each tour.'
  },
  {
    id: 2,
    question: 'How do I make a booking?',
    answer: 'You can book directly through our website by selecting your desired tour and completing the booking form. We accept PayPal payments. You will receive a confirmation email within 24 hours.'
  },
  {
    id: 3,
    question: 'What is your cancellation policy?',
    answer: 'Free cancellation up to 48 hours before the tour. Cancellations within 48 hours are subject to a 50% fee. No refund for no-shows. Weather-related cancellations receive full refunds.'
  },
  {
    id: 4,
    question: 'Are the tours suitable for children?',
    answer: 'Most tours are family-friendly. Quad biking requires riders to be 16+ years old. Safari tours are suitable for all ages. We recommend checking specific age requirements for each activity.'
  },
  {
    id: 5,
    question: 'Do you provide hotel pickup?',
    answer: 'Yes, complimentary hotel pickup and drop-off is included for all tours within Cape Town city center and Atlantic Seaboard. Safari tours include pickup from most Cape Town locations.'
  },
  {
    id: 6,
    question: 'What should I bring on the tours?',
    answer: 'We recommend comfortable clothing, sunscreen, hat, camera, and water. Closed shoes required for quad biking. Safari tours: binoculars recommended. Specific requirements are communicated upon booking.'
  }
];

// Mock booking function
export const createBooking = async (bookingData) => {
  // Simulate API call
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        success: true,
        bookingId: 'CAT' + Math.random().toString(36).substr(2, 9).toUpperCase(),
        message: 'Booking request submitted successfully!'
      });
    }, 1500);
  });
};

// Mock contact form submission
export const submitContactForm = async (formData) => {
  // Simulate API call
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        success: true,
        message: 'Thank you for contacting us! We will respond within 24 hours.'
      });
    }, 1000);
  });
};
